let BaseUrl = window.config.apiBaseUrl
export default {
  // Auth
  self: { method: 'GET', url: BaseUrl + 'api/account/self' },
  authenticate: { method: 'POST', url: BaseUrl + 'api/account/token/portal' },
  authenticateVasUser: { method: 'POST', url: BaseUrl + 'api/account/token/portal/vas' },
  // Landing Page
  getLandingPage: { method: 'GET', url: BaseUrl + 'api/landingpage/portal' },
  trackSessionEvent: { method: 'POST', url: BaseUrl + 'api/landingpagesession' },
  checkHeaderEnrichmentUsername: { method: 'POST', url: BaseUrl + 'subscribe/request/{code}' },
  // Subscription
  requestForSubscription: { method: 'POST', url: BaseUrl + 'api/subscribe/request' },
  initSubscription: { method: 'POST', url: BaseUrl + 'api/subscribe/request/{code}/init' },
  checkSubscriptionRequestStatus: { method: 'GET', url: BaseUrl + 'api/subscribe/request/{code}/state' },
  getUserStatus: { method: 'GET', url: BaseUrl + 'api/subscribe/userstate/{userName}' },
  getUserStatusZainjo: { method: 'GET', url: `https://api.beecell.com/index.php?r=api/GetUserInfo&msisdn={userName}&serviceId=12357` },
  getUserState: { method: 'GET', url: BaseUrl + 'api/subscribe/userstate/uuid' },
  unsubscribe: { method: 'POST', url: BaseUrl + 'api/subscribe/unsubscribe' },
  alreadySub: { method: 'POST', url: BaseUrl + 'api/subscribe/request/already' },
  checkAlreadyUserSub: { method: 'GET', url: BaseUrl + 'api/subscribe/request/{code}/username' },
  getValidations: { method: 'GET', url: BaseUrl + 'api/subscribe/providerdetails/{planProviderCode}' },
  getTpayDigest: { method: 'GET', url: BaseUrl + 'api/tpay/digest?providerCode={providerCode}' },
  // OTP
  verifyOtp: { method: 'POST', url: BaseUrl + 'api/otp' },
  resend: { method: 'POST', url: BaseUrl + 'api/otp/resend' },
  confirmUnsubscribe: { method: 'POST', url: BaseUrl + 'api/otp/confirmunsubscribe' },
  // Consent Page
  getSubUrl: { method: 'GET', url: BaseUrl + 'api/consentpage/subscribe/url?subscriptionMethodId={subscriptionMethodId}&gatewayPageCode={gatewayPageCode}&refCode={refCode}&callBackUrl={callBackUrl}&userUniqueIdentifier={userUniqueIdentifier}' },
  processMtnSubCallback: { method: 'POST', url: BaseUrl + 'api/consentpage/subscribe/mtn/callback' },
  processRgkSubCallback: { method: 'POST', url: BaseUrl + 'api/consentpage/subscribe/rgk/callback' },
  getUnsubUrl: { method: 'GET', url: BaseUrl + 'api/consentpage/unsubscribe/url?subscriptionMethodId={subscriptionMethodId}&gatewayPageCode={gatewayPageCode}&refCode={refCode}&callBackUrl={callBackUrl}&userUniqueIdentifier={userUniqueIdentifier}' },
  processMtnUnsubCallback: { method: 'POST', url: BaseUrl + 'api/consentpage/unsubscribe/mtn/callback' },
  processRgkUnsubCallback: { method: 'POST', url: BaseUrl + 'api/consentpage/unsubscribe/rgk/callback' },
  // Product Catalog
  getSliders: { method: 'GET', url: BaseUrl + 'api/productcatalog/slider?' },
  getCollections: { method: 'GET', url: BaseUrl + 'api/productcatalog/collection?PageIndex={pageIndex}&PageCount={pageCount}' },
  getCollection: { method: 'GET', url: BaseUrl + 'api/productcatalog/collection/{id}' },
  getGenres: { method: 'GET', url: BaseUrl + 'api/productcatalog/genre?PageIndex={pageIndex}&PageSize={pageSize}' },
  getGenre: { method: 'GET', url: BaseUrl + 'api/productcatalog/genre/{id}' },
  getProducts: { method: 'GET', url: BaseUrl + 'api/productcatalog/product?SkipCount={skipCount}&ResultCount={resultCount}{&Tags=tags}{&Genres=genres}{&Collections=collections}{&Types=types}{&RightTypes=rightTypes}{&Text=text}' },
  getProduct: { method: 'GET', url: BaseUrl + 'api/productcatalog/product/{id}' },
  getProductUrl: { method: 'GET', url: BaseUrl + 'api/productcatalog/product/{id}/url' },
  getDownloadToken: { method: 'GET', url: BaseUrl + 'api/cdn/download/ticket?uniqueFileName={uniqueFileName}&productId={productId}&tenantId={tenantId}' },
  downloadByTicket: { method: 'GET', url: BaseUrl + 'api/cdn/download/ticket/{ticket}' },
  // Contact Us
  sendContactUs: { method: 'POST', url: BaseUrl + 'api/contactus' },
  // Register
  registerWithUrl: { method: 'POST', url: BaseUrl + 'bazili/register/irankish?username={username}' },
  registerUser: {/* todo */ },
  confirmPin: {/* todo */ },
  checkUsernameExist: { method: 'GET', url: BaseUrl + 'api/account/checkusernameexist' },
  checkNicknameExist: { method: 'GET', url: BaseUrl + 'api/account/checknicknameexist' },
  setTrialPeriod: { method: 'POST', url: BaseUrl + 'bazili/register/trial' },

  // Login
  loginUser: { method: 'POST', url: BaseUrl + 'api/account/token/portal/organic' },
  // Profile
  getUserInfo: { method: 'GET', url: BaseUrl + 'api/account/userinfo' },
  getSubscriptionPlans: { method: 'GET', url: BaseUrl + 'api/sale/subscription/subscriptionplans/list' },
  updateUserInfo: { method: 'POST', url: BaseUrl + 'api/account/updateuserinfo' },
  // Sales
  addToBasket: { method: 'POST', url: BaseUrl + 'api/sale/basket/{basketCode}/items/subscription?planCode={planCode}' },
  applyDiscountCode: { method: 'PUT', url: BaseUrl + 'api/sale/{basketCode}/{planCode}/discount/{code}' },
  checkOut: { method: 'POST', url: BaseUrl + 'api/sale/{basketCode}/checkout' },
  pay: { method: 'GET', url: BaseUrl + 'api/payment/pay' },
  // Wallet
  getBalance: { method: 'GET', url: BaseUrl + 'api/wallet/balance' },
  charge: { method: 'GET', url: BaseUrl + 'api/wallet/charge' },
  paymentHistory: { method: 'GET', url: BaseUrl + 'api/wallet/transactions' },
  // Transactions
  getTransaction: { method: 'GET', url: BaseUrl + 'api/payment/status/{transactionId}' },
  // Reset Password
  sendResetToken: { method: 'POST', url: BaseUrl + 'api/account/sendresettoken' },
  verifyToken: { method: 'GET', url: BaseUrl + 'api/account/verifytoken?username={username}&token={token}' },
  resetPassword: { method: 'POST', url: BaseUrl + 'api/account/resetpassword' },

  // Feedback
  getComments: { method: 'GET', url: BaseUrl + 'api/feedback/commentlist?productid={productId}&state={state}&pageIndex={pageIndex}&size={pageSize}' },
  addComment: { method: 'POST', url: BaseUrl + 'api/feedback/comment' },
  likeComment: { method: 'PUT', url: BaseUrl + 'api/feedback/comment/{{id}}/like' },
  dislikeComment: { method: 'PUT', url: BaseUrl + 'api/feedback/comment/{{id}}/dislike' },
  getProductRate: { method: 'GET', url: BaseUrl + 'api/feedback/productrate/average/{productId}' },
  rateProduct: { method: 'POST', url: BaseUrl + 'api/feedback/productrate' },
  getUserProductRate: { method: 'GET', url: BaseUrl + 'api/feedback/productrate/byUser/{productId}' }
}
